module.exports = __webpack_public_path__ + "img/zhengshu5.005442f0.png";